<template>
  <div class="city-list">
    <div @click="showPopup=true" class="city-name">
      <span>{{city.name||'定位中...'}}</span>
      <span v-show="defaultText">(默认)</span>
      <slot name="icon"></slot>
    </div>
    <van-popup v-model="showPopup" position="right" get-container="body" :lock-scroll="false">
      <index-list :data="cityList" @select="selectItem" class="city-list-content">
        <index-list-group v-for="(group,index) in cityList" :key="index" :group="group">
          <index-list-item
            v-for="(item,index) in group.cities"
            :key="index"
            :item="item"
            @select="selectItem"
          >
            <div class="city-list-item">
              <span>{{item.name}}</span>
            </div>
          </index-list-item>
        </index-list-group>
      </index-list>
    </van-popup>
  </div>
</template>

<script>
import { getCityList } from 'common/js/api'
import { Popup } from 'vant'
import indexList from '../index-list/index-list'
import indexListGroup from '../index-list/index-list-group'
import indexListItem from '../index-list/index-list-item'
import Geolocation from 'common/js/geolocation'

import storejs from 'store'

export default {
  name: 'city-list',
  props: {
    miniprogram: {
      default: false,
      type: Boolean
    },
    city: {
      default() {
        return {}
      },
      type: Object
    }
  },
  data() {
    return {
      showPopup: false,
      cityList: [],
      defaultText: false
    }
  },
  created() {
    this.getCity()
    this.getCityList()
  },
  methods: {
    selectItem(item) {
      const city = JSON.parse(JSON.stringify(this.city))
      const obj = Object.assign(city, item)
      this.$emit('update:city', obj)
      this.defaultText = false
      this.showPopup = false
    },
    async getCity() {
      const geolocation = new Geolocation()
      if (!this.miniprogram) {
        const res = await geolocation.getLocation()
        if (res.code === 0) {
          this.city = res.data
          this.updateCity()
        } else {
          alert(res.msg)
        }
      } else {
        const res = await geolocation.getAmapLocation()
        if (res.code === 0) {
          this.city = res.data
          this.updateCity()
        } else {
          alert(res.msg)
        }
      }
    },
    async getCityList() {
      if (storejs.get('cityList')) {
        this.cityList = storejs.get('cityList')
        this.updateCity()
      } else {
        const res = await getCityList.call(this, false)
        if (res.code === 0) {
          this.cityList = res.data
          this.updateCity()
          storejs.set('cityList', this.cityList)
        } else {
          this.$toast(res.msg)
        }
      }
    },
    updateCity() {
      if (!this.city.city || this.cityList.length === 0) {
        return
      }
      for (let i = 0; i < this.cityList.length; i++) {
        for (let j = 0; j < this.cityList[i].cities.length; j++) {
          if (this.city.city.indexOf(this.cityList[i].cities[j].name.replace('地区', '')) > -1) {
            const city = JSON.parse(JSON.stringify(this.city))
            const obj = Object.assign(city, this.cityList[i].cities[j])
            this.$emit('update:city', obj)
            return
          }
        }
      }
      this.$nextTick(() => {
        if (!this.city.name) {
          const city = JSON.parse(JSON.stringify(this.city))
          const obj = Object.assign(city, this.cityList[0].cities[0])
          this.$emit('update:city', obj)
          this.defaultText = true
        }
      })
    }
  },
  components: {
    [Popup.name]: Popup,
    indexList,
    indexListGroup,
    indexListItem
  }
}
</script>

<style lang="scss" scoped>
.city-name {
  display: flex;
  align-items: center;
}
.city-list-content {
  width: 510px;
  font-weight: normal;
  .city-list-item {
    display: flex;
    align-items: center;
  }
}
</style>
